import { Reveal, Eyebrow } from "../components/Reveal";

const galleryItems = [
  { src: "/assets/gallery/gallery-2.jpg", caption: "Independence Day Ceremonial Celebrations", tag: "Security" },
  { src: "/assets/gallery/gallery-4.jpg", caption: "Independence Day Celebrations", tag: "Valet" },
  { src: "/assets/gallery/gallery-5.jpg", caption: "Recognition at BNI corporate meet", tag: "Events" },
  { src: "/assets/gallery/gallery-3.jpg", caption: "Corporate networking at BNI Zenith", tag: "Events" },
  { src: "/assets/gallery/gallery-6.jpg", caption: "Security at your Premises", tag: "Security", pos: "object-[50%_25%]" },
  { src: "/assets/gallery/gallery-7.jpg", caption: "Security Team", tag: "Security" },
  { src: "/assets/gallery/gallery-8.jpg", caption: "Salute drill at construction post", tag: "Security" },
  { src: "/assets/gallery/gallery-9.jpg", caption: "Gate duty at Duplex Towers", tag: "Security" },
  { src: "/assets/gallery/gallery-11.jpg", caption: "Housekeeping team at Shangrila", tag: "Housekeeping" },
  { src: "/assets/gallery/gallery-12.jpg", caption: "Terrace housekeeping duty", tag: "Housekeeping" },
  { src: "/assets/gallery/gallery-14.jpg", caption: "Night shift team lineup", tag: "Security" },
  { src: "/assets/gallery/gallery-15.jpg", caption: "Supervisor with the team at Shangrila", tag: "Housekeeping" },
  { src: "/assets/gallery/gallery-16.jpg", caption: "Evening briefing at site entrance", tag: "Security" },
  { src: "/assets/gallery/gallery-17.jpg", caption: "Morning roll-call briefing", tag: "Security" },
  { src: "/assets/gallery/gallery-18.jpg", caption: "Night shift parade", tag: "Security" },
  { src: "/assets/gallery/gallery-19.jpg", caption: "Team lineup, ready for duty", tag: "Security" },
];

export default function Gallery() {
  return (
    <>
      <section className="bg-white border-b border-slate-200">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-24">
          <Reveal>
            <Eyebrow>Gallery</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] text-slate-900" data-testid="gallery-headline">
              Our work, in frames.
            </h1>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-600">
              A look at our teams, ceremonies, events and on-site operations.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F8FAFC] py-20 lg:py-28" data-testid="gallery-page">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryItems.map((item, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1}>
              <div
                data-testid={`gallery-item-${i}`}
                onContextMenu={(e) => e.preventDefault()}
                className="group relative w-full overflow-hidden rounded-2xl border border-slate-200/80 hover:border-sky-500/40 hover:shadow-[0_20px_40px_-15px_rgba(2,132,199,0.12)] transition-all duration-300 select-none"
              >
                <img
                  src={item.src}
                  alt={item.caption}
                  draggable={false}
                  className={`h-72 w-full object-cover ${item.pos || "object-center"} transition-transform duration-700 group-hover:scale-105 pointer-events-none`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1528]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 inset-x-0 p-5 text-left translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-sky-300">{item.tag}</span>
                  <p className="text-sm font-semibold text-white mt-1">{item.caption}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
